import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayTableComponent } from './display-table/display-table.component';
import { CreateDisplayComponent } from './create-display/create-display.component';
import { DisplayIndicatorsComponent } from './display-indicators/display-indicators.component';
import { DisplayRoutingModule } from './display-routing.module';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    DisplayTableComponent,
    CreateDisplayComponent,
    DisplayIndicatorsComponent
  ],
  imports: [
    CommonModule,
    DisplayRoutingModule,
    SharedModule
  ]
})
export class DisplayModule { }
